export const HTTP_HEADERS = {
  authorization: 'authorization',
  xAppLocale: 'x-app-locale',
  xRedirectTo: 'x-redirect-to',
  xRedirectUrl: 'x-redirect-url',
  xTransactionEntryId: 'x-transaction-entry-id',
} as const;
